import React from "react";
import { Link } from "react-router-dom";

const ProfileItemLink = (props) => {
  const { link, title, image, onClickFunction } = props || {};

  const Content = link ? (
    <Link to={link}>
      <div className="other-profile-info-links-item">
        <div className="other-profile-info-links-item-text">
          {image && <img src={image} className="img-fluid" alt="LG" />} {title}
        </div>
        <div className="other-profile-info-links-item-icon">
          <img src="/images/arrow-right.png" className="img-fluid" alt="LG" />
        </div>
      </div>
    </Link>
  ) : (
    <div
      className="other-profile-info-links-item"
      onClick={() => onClickFunction()}
    >
      <div className="other-profile-info-links-item-text">
        {image && <img src={image} className="img-fluid" alt="LG" />} {title}
      </div>
      <div className="other-profile-info-links-item-icon">
        <img src="/images/arrow-right.png" className="img-fluid" alt="LG" />
      </div>
    </div>
  );

  return Content;
};

export default ProfileItemLink;
